import { useState } from "react";
import { motion } from "framer-motion";

export const CARRIERS = [
  ["canada_post", "Canada Post"], ["purolator", "Purolator"], ["ups", "UPS"], ["fedex", "FedEx"], ["canpar", "Canpar"], ["other", "Other courier"],
];
const field = "w-full bg-[#111A14] border border-[#303B2D] rounded-sm px-3 py-2.5 text-[14px] text-[#E8DDC7] focus:outline-none focus:border-[#B5A642]/70";

export const ShipDialog = ({ order, onCancel, onConfirm }) => {
  const [carrier, setCarrier] = useState("canada_post");
  const [tracking, setTracking] = useState("");
  const [send, setSend] = useState(true);
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    await onConfirm({ carrier, tracking: tracking.trim(), send_letter: send });
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4" data-testid="ship-dialog">
      <div className="absolute inset-0 bg-[#111A14]/75 backdrop-blur-sm" onClick={onCancel} />
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}
        className="relative w-full max-w-md bg-[#1C1F1E] border border-[#B5A642]/40 rounded-sm p-7">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#B5A642]">Order {order.reference}</p>
        <h3 className="mt-2 font-display text-3xl text-[#E8DDC7]">Send it on its way</h3>
        <p className="mt-1 text-[13px] text-[#D3CEC4]/55">{order.name} · {order.email}</p>
        <label className="block mt-6 text-[10px] uppercase tracking-[0.25em] text-[#D3CEC4]/50">Carrier</label>
        <select data-testid="ship-carrier" value={carrier} onChange={(e) => setCarrier(e.target.value)} className={`${field} mt-1.5`}>
          {CARRIERS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <label className="block mt-4 text-[10px] uppercase tracking-[0.25em] text-[#D3CEC4]/50">Tracking number (optional)</label>
        <input data-testid="ship-tracking" value={tracking} onChange={(e) => setTracking(e.target.value)} maxLength={60}
          placeholder="e.g. 7023 2101 0001 2345" className={`${field} mt-1.5 font-ledger tracking-wide`} />
        <label className="mt-5 flex items-start gap-2.5 cursor-pointer">
          <input type="checkbox" data-testid="ship-send-letter" checked={send} onChange={(e) => setSend(e.target.checked)} className="mt-0.5 accent-[#B5A642] w-4 h-4" />
          <span className="text-[13px] text-[#D3CEC4]/70">Send the "your jars are on their way" letter to the customer</span>
        </label>
        <div className="mt-7 flex gap-3">
          <button data-testid="ship-confirm" onClick={confirm} disabled={busy}
            className="flex-1 py-3 bg-[#4B3226] text-[#E8DDC7] text-[11px] uppercase tracking-[0.2em] rounded-sm hover:brightness-125 transition-[filter] disabled:opacity-50">
            {busy ? "Sealing…" : send ? "Mark shipped & send" : "Mark shipped"}
          </button>
          <button data-testid="ship-cancel" onClick={onCancel} className="px-5 py-3 border border-[#303B2D] text-[11px] uppercase tracking-[0.2em] text-[#D3CEC4]/60 rounded-sm hover:text-[#E8DDC7] transition-colors">
            Cancel
          </button>
        </div>
      </motion.div>
    </div>
  );
};
